/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CounterStatusStatusEnum {
    IN_PROGRESS = 'IN_PROGRESS',
    DISABLED = 'DISABLED',
}